module.exports = __webpack_public_path__ + "assets/images/Sync3.206c1468.jpg";